<template>
  <div style="margin-top: 10px;">
    <a-table
      size="small"
      :dataSource="dataSource"
      :columns="columns"
      :pagination="false"
    >
      <template #bodyCell="{ column,record }">
        <template v-if="column.key === 'no'">
          {{ record.id }}
        </template>
        <template v-if="column.key === 'lastUpdateTime'">
          {{ record.userName }}/{{ record.lastUpdateTime }}
        </template>
        <template v-if="column.key === 'status'">
          <!-- 调试中 可上线 -->
          <div v-if="record.status === 0" class="box">
            <!-- <div
              style="width: 10px;height: 10px;background-color: orange;"
            ></div>
            <div>调试中</div> -->
            <a-tag color="orange">调试中</a-tag>
            <div style="width: 88px; text-align: left">
              <a-popconfirm
                title="确定上线实验吗?"
                okText="确定上线"
                cancelText="取消"
                @confirm="lineConfirm(record.id)"
              >
                <a-button size="small" type="link">上线</a-button>
              </a-popconfirm>
            </div>
          </div>
          <!-- 运行中 可暂停 可下线 -->
          <div v-if="record.status === 1" class="box">
            <!-- <div
              style="width: 10px;height: 10px;background-color: aquamarine;"
            ></div>
            <div>运行中</div> -->
            <a-tag color="green">运行中</a-tag>
            <div style="width: 88px">
              <a-popconfirm
                title="确定暂停实验吗?"
                okText="确定暂停"
                cancelText="暂不暂停"
                @confirm="stop(record.id)"
              >
                <a-button size="small" type="link">暂停</a-button>
              </a-popconfirm>
              <a-popconfirm
                title="确定下线实验吗?"
                okText="确定下线"
                cancelText="暂不下线"
                @confirm="offlineConfirm(record.id)"
              >
                <a-button size="small" type="link">下线</a-button>
              </a-popconfirm>
            </div>
          </div>
          <!-- 已结束 不可操作 -->
          <div v-if="record.status === 2" class="box">
            <!-- <div
              style="width: 10px;height: 10px;background-color: darkgrey;"
            ></div>
            <div>已结束</div> -->
            <a-tag color="darkgrey">已结束</a-tag>
            <div style="width: 88px;"></div>
          </div>
          <!-- 暂停中 可上线 -->
          <div v-if="record.status === 3" class="box">
            <!-- <div
              style="width: 10px;height: 10px;background-color: orange;"
            ></div>
            <div>暂停中</div> -->
            <a-tag color="pink">暂停中</a-tag>
            <div style="width: 88px; text-align: left">
              <a-popconfirm
                title="确定上线实验吗?"
                okText="确定上线"
                cancelText="取消"
                @confirm="lineConfirm(record.id)"
              >
                <a-button size="small" type="link">上线</a-button>
              </a-popconfirm>
            </div>
          </div>
        </template>
        <template v-if="column.key === 'action'">
          <a-button
            :disabled="record.status === 0"
            type="link"
            @click.stop="showReport(record.id)"
            >实验报告</a-button
          >
          <a-space>
            <a-button
              :disabled="record.status === 2"
              size="small"
              type="link"
              @click.stop="editDrawerInfo(record.id)"
              >编辑</a-button
            >

            <a-button
              size="small"
              type="link"
              @click.stop="editDrawerInfo(record.id, true)"
              >复制</a-button
            >

            <a-popconfirm
              v-if="[1, 3].indexOf(record.status) < 0"
              title="删除后将无法找回，请确认？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="changeStatus(record.id, record.status)"
            >
              <a-button size="small" type="link">删除</a-button>
            </a-popconfirm>
            <a-popconfirm
              v-if="[1, 3].indexOf(record.status) >= 0"
              title="运行中的实验，请先下线后再操作删除!"
              ok-text="确认"
              cancel-text="取消"
            >
              <a-button size="small" type="link">删除</a-button>
            </a-popconfirm>
            <a-button type="link" @click.stop="showLogModal(record.id)"
              >日志</a-button
            >
          </a-space>
        </template>
      </template>
    </a-table>
  </div>
  <div style="margin-top: 10px;display: flex; justify-content: space-between">
    <div>
      共 {{ searchForm.total }} 条记录 第 {{ searchForm.pageNum }} /
      {{ searchForm.pages }} 页
    </div>
    <a-pagination
      v-model:current="searchForm.pageNum"
      :pageSize="searchForm.pageSize"
      :page-size-options="pageSizeOptions"
      show-quick-jumper
      show-size-changer
      :total="searchForm.total"
      @change="onPageChange"
    >
      <template #buildOptionText="props">
        <span>{{ props.value }}条/页</span>
      </template>
    </a-pagination>
  </div>
</template>
<script>
import { defineComponent, inject, reactive, toRefs } from 'vue'
export default defineComponent({
  name: 'AddressRule',
  setup() {
    const state = reactive({
      pageSizeOptions: ['20', '50', '100'],
      statusMap: {
        0: {
          color: '#eee',
          label: '已结束'
        },
        1: {
          color: '#0f0',
          label: '运行中'
        },
        2: {
          color: '#ff0',
          label: '调试中'
        },
        3: {
          color: '#f00',
          label: '运行中（暂停）'
        }
      },
      statusRender: e => {
        e = e + ''
        return state.statusMap[Object.keys(state.statusMap).includes(e) ? e : 0]
      }
    })
    return {
      ...toRefs(state),
      ...toRefs(inject('initState'))
    }
  }
})
</script>

<style>
.box {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
